/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { useMemo } from 'react';

function useDefaultProps(originalProps, defaultProps) {
  return useMemo(function () {
    var props = Object.assign({}, originalProps);
    Object.keys(defaultProps).forEach(function (key) {
      if (props[key] === void 0) {
        props[key] = defaultProps[key];
      }
    });
    return props;
  }, [originalProps, defaultProps]);
}

export { useDefaultProps as default };
//# sourceMappingURL=useDefaultProps.js.map
